import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const i18n = new VueI18n({
    locale: localStorage.getItem('language') || process.env.VUE_APP_I18N_LOCALE || 'zh-TW', // 设置默认语言环境，例如从环境变量获取或'en'
    fallbackLocale: 'zh-TW', // 设置回退语言环境，例如当翻译缺失时使用英文显示
    messages: loadLocaleMessages() // 设置地区信息
});

export default i18n;